import {gql} from '@apollo/client';

export const PARTIAL_WORKOUT_FRAGMENT = gql`
    fragment PartialWorkout on Workout {
        id
        user_id
        execution_type
        executed_at_iso8601
        title
        track_geo_url
        track_geo_strokes_url
        share_url
        machine_configurations {
            machine_type
            boat_type
            weight_grams
        }
        workout_part_results {
            stroke_count
            elapsed_time_millis
            traveled_distance_millimeters
            burned_calories
        }
        training_plan {
            title
        }
        public_user {
            display_name
        }
    }
`;

export const FULL_WORKOUT_FRAGMENT = gql`
    fragment FullWorkout on Workout {
        id
        user_id
        original_user_id
        execution_type
        executed_at_iso8601
        title
        share_url
        is_claimed
        track_geo_url
        track_geo_strokes_url
        track_heart_rate_url
        strava_synced
        machine_configurations {
            machine_type
            boat_type
            weight_grams
        }
        workout_part_results {
            stroke_count
            elapsed_time_millis
            traveled_distance_millimeters
            burned_calories
            average_power_watts
            average_relative_peak_force_position
            average_split_millis
            average_peak_force
            average_stroke_length_millimeters
            average_energy_per_stroke
            average_stroke_rate
            average_drive_time_millis
            average_recover_time_millis
            total_energy_joules
        }
        training_plan {
            title
            workouts {
                id
                executed_at_iso8601
            }
            intervals {
                repetitions
                parts {
                    type
                }
            }
        }
        public_user {
            display_name
        }
    }
`;

export const PUBLIC_WORKOUT_FRAGMENT = gql`
    fragment FullWorkout on PublicWorkout {
        id
        execution_type
        executed_at_iso8601
        title
        share_url
        track_geo_url
        is_claimed
        machine_configurations {
            machine_type
            boat_type
            weight_grams
        }
        workout_part_results {
            stroke_count
            elapsed_time_millis
            traveled_distance_millimeters
            burned_calories
            average_power_watts
            average_relative_peak_force_position
            average_split_millis
            average_peak_force
            average_stroke_length_millimeters
            average_energy_per_stroke
            average_stroke_rate
            average_drive_time_millis
            average_recover_time_millis
            total_energy_joules
        }
        training_plan {
            title
            workouts {
                id
                executed_at_iso8601
            }
            intervals {
                repetitions
                parts {
                    type
                }
            }
        }
    }
`;
